export default __webpack_public_path__ + "static/media/67e4c5bdfa092b60dc141941a7ede125.2abb26df.svg";